module.exports = __webpack_public_path__ + "static/logo-48eb2e4110e5b2cbc080093e22878976.png";